import { unassignedPaymentsAtom } from "Payment/Atom/paymentAtom";
import { useUnassignedPaymentsTable } from "Payment/Components/Tables/Hooks/useUnassignedPaymentsTable";
import { Table } from "Shared/Components/Table";
import { Alert, Box, Typography } from "@mui/material";
import { useAtom } from "jotai";

export function UnassignedPaymentsTab() {
	const { tableOptions, modal } = useUnassignedPaymentsTable();
	const [unassignedPaymentsNum] = useAtom(unassignedPaymentsAtom);

	return (
		<Box display="flex" flexDirection="column" gap={2}>
			{unassignedPaymentsNum > 0 ? (
				<Alert severity="warning" variant="outlined" color="warning">
					<Typography fontWeight="bold" fontSize="inherit">
						There are {unassignedPaymentsNum} unassigned payments.
					</Typography>
				</Alert>
			) : (
				<Alert severity="success" variant="outlined" color="success">
					<Typography fontWeight="bold" fontSize="inherit">
						No unassigned payments found.
					</Typography>
				</Alert>
			)}
			{unassignedPaymentsNum > 0 && <Table tableOptions={tableOptions} />}
			{modal}
		</Box>
	);
}
